import comp from "./Preview";
export default comp;
